import { render, staticRenderFns } from "./TwoStepAuthenticationModal.vue?vue&type=template&id=c0b652ea&scoped=true"
import script from "./TwoStepAuthenticationModal.vue?vue&type=script&lang=js"
export * from "./TwoStepAuthenticationModal.vue?vue&type=script&lang=js"
import style0 from "./TwoStepAuthenticationModal.vue?vue&type=style&index=0&id=c0b652ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b652ea",
  null
  
)

export default component.exports